import phoneTypes from '../../enums/phoneTypes';

export default {
  [phoneTypes.business]: 'Telefon (geschäftlich)',
  [phoneTypes.extension]: 'Durchwahltelefon',
  [phoneTypes.home]: 'Telefon (privat)',
  [phoneTypes.mobile]: 'Mobiltelefon',
  [phoneTypes.phone]: 'Telefon',
  [phoneTypes.unknown]: 'Unbekannter Telefontyp',
};
